// extracted by mini-css-extract-plugin
module.exports = {"speakers_header":"styles_speakers_header__W_SQh","speaker_grid":"styles_speaker_grid__GY__I","fade-out":"styles_fade-out__D67wW","fade-in":"styles_fade-in__vB4fp"};